/* DOMNO. spin popup v2, part 2 of 2: Klaviyo, the code, the forms and when it shows. Needs domno-spin-1.js first. */
(function () {
  'use strict';
  var D = window.__ds;
  if (!D || D.wired) return;
  D.wired = true;
  var root = D.root, CFG = D.CFG, qs = D.qs, DEMO = D.DEMO, FORCE_LIVE = D.FORCE_LIVE;
  var $ = D.$, $$ = D.$$, store = D.store, state = D.state, goto = D.goto, open = D.open, close = D.close;

  /* ---------- network ---------- */
  function kpost(path, body) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + CFG.companyId, {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'revision': CFG.revision },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok && r.status !== 202) throw new Error('klaviyo ' + r.status); return r; });
  }
  function withTimeout(p, ms) {
    return Promise.race([p, new Promise(function (_, rej) { setTimeout(function () { rej(new Error('timeout')); }, ms); })]);
  }
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  function getCode(email, name) {
    if (DEMO) return wait(700).then(function () { return { code: 'SPIN15-DEMO42' }; });
    return withTimeout(fetch(CFG.codeEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email, first_name: name, country: root.getAttribute('data-country') })
    }).then(function (r) { if (!r.ok) throw new Error('code ' + r.status); return r.json(); }), 7000);
  }

  function subscribeEmail(email, name, code) {
    if (DEMO) return Promise.resolve();
    var profile = { data: { type: 'profile', attributes: { email: email, first_name: name, properties: { popup_variant: CFG.variant, coupon: 'discount' } } } };
    var sub = { data: { type: 'subscription', attributes: { custom_source: CFG.source,
      profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } },
      relationships: { list: { data: { type: 'list', id: CFG.listEmail } } } } };
    return kpost('profiles', profile).catch(function () {}).then(function () {
      return kpost('subscriptions', sub).catch(function () { return kpost('subscriptions', sub); });
    }).then(function () {
      try { if (window.klaviyo && klaviyo.identify) klaviyo.identify({ email: email, first_name: name }); } catch (e) {}
      track('Spin Popup Submitted', { code_shown: !!code, popup_variant: CFG.variant }, email);
    });
  }

  function subscribeSms(phone) {
    if (DEMO) return wait(600);
    var sub = { data: { type: 'subscription', attributes: { custom_source: CFG.source + ' (SMS)',
      profile: { data: { type: 'profile', attributes: { email: state.email, phone_number: phone, subscriptions: { sms: { marketing: { consent: 'SUBSCRIBED' } } } } } } },
      relationships: { list: { data: { type: 'list', id: CFG.listSms } } } } };
    return kpost('subscriptions', sub).then(function () { track('Spin Popup SMS Entered', {}, state.email); });
  }

  function track(metric, props, email) {
    if (DEMO) return;
    var em = email || state.email;
    try { if (window.dataLayer) dataLayer.push({ event: 'ds_' + metric.toLowerCase().replace(/\s+/g, '_') }); } catch (e) {}
    if (!em) return;
    kpost('events', { data: { type: 'event', attributes: { properties: props || {},
      metric: { data: { type: 'metric', attributes: { name: metric } } },
      profile: { data: { type: 'profile', attributes: { email: em } } } } } }).catch(function () {});
  }

  /* ---------- forms ---------- */
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  function showErr(el, msg) { el.textContent = msg; el.hidden = !msg; }
  function bad(input, on) {
    var f = input.closest('.ds-field');
    f.classList.toggle('is-bad', on);
    if (on) { f.classList.remove('is-shake'); void f.offsetWidth; f.classList.add('is-shake'); }
  }
  function loading(btn, on) { btn.disabled = on; btn.classList.toggle('is-loading', on); }

  function onEmailSubmit(e) {
    e.preventDefault();
    var f = e.currentTarget, err = $('[data-ds-err]');
    var nameI = f.elements.first_name, mailI = f.elements.email;
    var name = (nameI.value || '').trim(), email = (mailI.value || '').trim().toLowerCase();
    bad(nameI, !name); bad(mailI, !!name && !EMAIL_RE.test(email));
    if (!name) { nameI.focus(); return showErr(err, 'We need your first name.'); }
    if (!EMAIL_RE.test(email)) { mailI.focus(); return showErr(err, "That email doesn't look right."); }
    showErr(err, '');
    var btn = f.querySelector('button[type=submit]');
    loading(btn, true);
    state.name = name; state.email = email;
    if (document.activeElement && document.activeElement.blur) document.activeElement.blur();

    getCode(email, name).then(function (d) { if (d && d.existing) state.existing = true; return d && d.code ? d.code : ''; }, function () { return ''; })
      .then(function (code) {
        // Already a customer: no code and no welcome-flow sign-up, just a friendly hello
        if (state.existing) { track('Spin Popup Existing Customer', {}, email); return null; }
        state.code = code; return subscribeEmail(email, name, code).then(function () { return code; });
      })
      .then(function (code) { store.set('done', '1'); if (state.existing) return showExisting(); showCode(code); applyCode(code); })
      .catch(function () {
        loading(btn, false);
        if (state.code) { store.set('done', '1'); showCode(state.code); applyCode(state.code); return; }
        showErr(err, "Couldn't sign you up just then. Mind trying again?");
      });
  }

  function showExisting() {
    root.classList.add('is-existing');
    $('[data-ds-hello]').textContent = state.name ? 'Hey ' + state.name + ', good to see you' : 'Good to see you';
    $('[data-ds-hascode]').hidden = true;
    var nc = $('[data-ds-nocode]'); nc.hidden = false;
    var p = nc.querySelector('p'); if (p) p.textContent = "Looks like you’re already part of the DOMNO. family, so this one’s for new faces. Good to see you back!";
    $('[data-ds-sms]').hidden = true;
    goto('code');
  }

  function applyCode(code) {
    if (!code) return;
    var done = function () { $('[data-ds-applied]').hidden = false; };
    if (DEMO) return setTimeout(done, 700);
    fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).then(function (r) { if (r.ok) done(); }, function () {});
  }

  function showCode(code) {
    $('[data-ds-hello]').textContent = state.name ? 'Nice one, ' + state.name : 'Nice one';
    $('[data-ds-hascode]').hidden = !code;
    $('[data-ds-nocode]').hidden = !!code;
    if (code) $('[data-ds-codetext]').textContent = code;
    var country = root.getAttribute('data-country');
    $('[data-ds-sms]').hidden = !(CFG.smsCountries.indexOf(country) > -1 || DEMO);
    var cc = { GB: '44', US: '1', CA: '1', AU: '61', NZ: '64', IE: '353' }[country];
    if (cc) { var sel = $('#ds-cc'); for (var i = 0; i < sel.options.length; i++) if (sel.options[i].value === cc) { sel.selectedIndex = i; break; } }
    goto('code');
  }

  function onCopy() {
    var t = $('[data-ds-copy]'), code = $('[data-ds-codetext]').textContent, label = $('[data-ds-copied] span');
    var done = function () {
      t.classList.add('is-copied'); label.textContent = 'Copied';
      try { if (navigator.vibrate) navigator.vibrate(8); } catch (e) {}
      setTimeout(function () { t.classList.remove('is-copied'); label.textContent = 'Copy'; }, 1800);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, done);
    else {
      var ta = document.createElement('textarea'); ta.value = code; document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); } catch (e) {} document.body.removeChild(ta); done();
    }
  }

  function onSmsSubmit(e) {
    e.preventDefault();
    var f = e.currentTarget, err = $('[data-ds-smserr]'), cc = f.elements.cc.value;
    var digits = (f.elements.phone.value || '').replace(/[^\d]/g, '').replace(/^0+/, '');
    if (digits.indexOf(cc) === 0 && digits.length > 10) digits = digits.slice(cc.length);
    var ok = digits.length >= 6 && digits.length <= 13;
    bad(f.elements.phone, !ok);
    if (!ok) return showErr(err, "That number doesn't look right.");
    showErr(err, '');
    var btn = f.querySelector('button[type=submit]');
    loading(btn, true);
    subscribeSms('+' + cc + digits).then(function () {
      $('[data-ds-sms]').hidden = true;
      $('[data-ds-entered]').hidden = false;
    }, function () {
      loading(btn, false);
      showErr(err, "Couldn't add your number just then. Mind trying again?");
    });
  }

  /* ---------- wiring ---------- */
  D.track = track;
  $$('[data-ds-close]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); close(); }); });
  $('[data-ds-form]').addEventListener('submit', onEmailSubmit);
  $('[data-ds-smsform]').addEventListener('submit', onSmsSubmit);
  $('[data-ds-copy]').addEventListener('click', onCopy);
  $('[data-ds-teaser]').addEventListener('click', function () { open(); });
  $$('.ds-field input').forEach(function (i) { i.addEventListener('input', function () { i.closest('.ds-field').classList.remove('is-bad'); }); });

  /* ---------- demo jump states (?dp=spin&ds_step=) ---------- */
  function demoWon() { D.setRot(-60 + 14); D.markWon(1); }
  function demoJump(s) {
    if (s === 'form') { demoWon(); open('form'); return; }
    if (s === 'code' || s === 'sent' || s === 'done') {
      demoWon(); state.name = 'Sam'; open('form');
      showCode(s === 'sent' ? '' : 'SPIN15-DEMO42');
      if (s !== 'sent') $('[data-ds-applied]').hidden = false;
      if (s === 'done') { $('[data-ds-sms]').hidden = true; $('[data-ds-entered]').hidden = false; }
      return;
    }
    open('wheel');
  }

  /* ---------- should it show? ---------- */
  function blocked() {
    if (root.getAttribute('data-customer') === 'true') return true;
    if (store.get('done')) return true;
    var snooze = parseInt(store.get('snooze') || '0', 10);
    if (snooze && Date.now() < snooze) return true;
    if (/^\/(cart|checkout|account|challenge)/.test(location.pathname)) return true;
    if (qs.get('_kx') || qs.get('utm_medium') === 'email' || qs.get('utm_medium') === 'sms') return true;
    return false;
  }
  function identified() {
    try {
      if (window.klaviyo && typeof klaviyo.isIdentified === 'function') {
        return withTimeout(Promise.resolve(klaviyo.isIdentified()), 1500).catch(function () { return false; });
      }
    } catch (e) {}
    return Promise.resolve(false);
  }
  function showTeaser() {
    state.won = !!store.sget('won');
    if (state.won) demoWon();
    root.hidden = false; root.classList.add('is-teaser');
    var t = $('[data-ds-teaser]'); t.querySelector('b').textContent = state.won ? 'Your 15% off' : 'Spin to win'; t.hidden = false;
  }

  if (DEMO) { setTimeout(function () { demoJump(qs.get('ds_step') || 'wheel'); }, 400); return; }
  if (FORCE_LIVE) { setTimeout(function () { open('wheel'); }, 400); return; }

  // Intelligems sets window.DOMNO_POPUP as it loads. Usually ~2-3s, but on slow phones it can be later,
  // so keep checking every half second for up to 20s. Opens 5s after the page loads, or as soon as Intelligems is ready if that's later.
  (function whenReady(fn) {
    var t0 = Date.now();
    (function check() {
      if (window.DOMNO_POPUP) return fn();
      if (Date.now() - t0 < 20000) setTimeout(check, 500);
    })();
  })(function () { setTimeout(function () {
    if (window.DOMNO_POPUP !== 'spin') return;
    if (store.get('done')) return;
    if (blocked()) return;
    identified().then(function (yes) { if (!yes) open('wheel'); });
  }, Math.max(0, CFG.delayMs - (window.performance ? performance.now() : 0))); });
})();